import React from 'react';
import { CheckCircle2, Code2, MonitorSmartphone, ServerCog } from 'lucide-react';
import { appMeta } from '@/config/iphonefastflip';

const groups = [
  {
    icon: MonitorSmartphone,
    title: 'Aplikacja',
    items: [
      'Responsywny wybór układu Android lub Windows w wersji webowej',
      'Pulpit, ogłoszenia, szczegóły, ulubione, alerty i konto',
      'Cenniki z importem JSON i cenami według stanu urządzenia',
      'Plany, Stripe Checkout i portal rozliczeniowy',
    ],
  },
  {
    icon: ServerCog,
    title: 'Dane i backend',
    items: [
      'Źródła OLX, Allegro Lokalnie i Vinted',
      'Konta Firebase z weryfikacją e-mail oraz telefonu',
      'Synchronizacja ulubionych, profilu i rekomendacji',
      'Lokalne usługi testowe na portach 8080 i 8091',
    ],
  },
  {
    icon: Code2,
    title: 'Wersja webowa',
    items: [
      'Build osadzony pod /iphonefastflip/',
      'Obsługa instalacji jako PWA',
      'Dopasowanie do telefonu, tabletu i szerokiego monitora',
      'Wspólna baza kodu Flutter z Androidem i Windowsem',
    ],
  },
] as const;

const Changelog: React.FC = () => (
  <main className="px-4 pb-24 pt-28 sm:pt-32">
    <div className="mx-auto max-w-5xl">
      <header className="mb-14 text-center">
        <p className="section-eyebrow">Dziennik zmian</p>
        <h1 className="text-4xl font-black tracking-[-0.04em] text-white sm:text-6xl">iPhoneFastFlip {appMeta.version}</h1>
        <p className="section-copy mx-auto mt-5 max-w-2xl">Bieżąca wersja testowa przygotowana dla Androida, Windowsa i przeglądarki.</p>
      </header>

      <div className="rounded-[30px] border border-blue-400/20 bg-blue-500/[0.07] p-6 sm:p-9">
        <div className="mb-8 flex flex-wrap items-center justify-between gap-4 border-b border-white/[0.08] pb-6">
          <div>
            <div className="mb-2 flex items-center gap-3">
              <h2 className="text-3xl font-black text-white">v{appMeta.version}</h2>
              <span className="rounded-full bg-emerald-500/10 px-3 py-1 text-xs font-bold text-emerald-400">AKTUALNA</span>
            </div>
            <p className="text-sm text-slate-500">Stan projektu: wersja do lokalnych testów integracyjnych</p>
          </div>
          <CheckCircle2 className="h-9 w-9 text-blue-400" />
        </div>

        <div className="grid gap-5 lg:grid-cols-3">
          {groups.map((group) => {
            const Icon = group.icon;
            return (
              <section key={group.title} className="rounded-2xl border border-white/[0.07] bg-[#0b1019]/70 p-5">
                <Icon className="mb-4 h-6 w-6 text-blue-300" />
                <h3 className="text-lg font-bold text-white">{group.title}</h3>
                <ul className="mt-4 space-y-3">
                  {group.items.map((item) => (
                    <li key={item} className="flex gap-2.5 text-sm leading-6 text-slate-400">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-blue-400" />
                      {item}
                    </li>
                  ))}
                </ul>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  </main>
);

export default Changelog;
